import React from 'react';
import PlansCardSearsContainer from '../containers/PlansCardSearsContainer'
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'

const ContactsPage = ({ match, location }) => {
    const { 
        state: { searsCardNumber, serviceDataInfo, sdkVersion, paymentsConfig, isClaroPartner}
    } = location;
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="contacts-page">
            <PlansCardSearsContainer 
                searsCardNumber={searsCardNumber}
                serviceDataInfo={serviceDataInfo}
                sdkVersion = {sdkVersion}
                paymentsConfig = {paymentsConfig}
                isClaroPartner = {isClaroPartner}
            />
        </Page>    
  );
};


export default ContactsPage